import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative mx-auto rounded-lg flex flex-grow-0 flex-shrink-0 flex-[calc(100%-16px)] flex-col w-full bg-white" }
const _hoisted_2 = { class: "flex-1 h-0 p-4 overflow-y-auto" }
const _hoisted_3 = { class: "flex-1 bg-white space-y-4" }
const _hoisted_4 = {
  key: 1,
  class: "md:flex md:flex-shrink-0"
}
const _hoisted_5 = { class: "flex flex-col flex-col w-56 pt-8 pb-4 shadow-modal bg-white wrh-scroll" }
const _hoisted_6 = { class: "flex items-center flex-shrink-0 px-4" }
const _hoisted_7 = { class: "mt-16 flex-1 px-4 bg-white space-y-6" }
const _hoisted_8 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_9 = {
  key: 1,
  class: "text-red-600 ml-2"
}

import {
  PropType, computed, toRefs, ref, onMounted, watch,
} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue';
import { XIcon } from '@heroicons/vue/outline';
import { useAuth, isMobile } from '@/util/funcs';
import { NavigationLinks } from '@/types';
import store from '@/store';
import { IConversations, ReqHomesDocument } from '@/models';
import SidebarIcon from './icons/SidebarIcon.vue';
import Logo from './icons/Logo.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  sidebarOpen: {
    type: Boolean,
    required: true,
  },
  navigation: {
    type: Array as PropType<NavigationLinks>,
    required: true,
  },
},
  emits: ['closeSidebar'],
  setup(__props, { emit }) {

const props = __props


const { navigation, sidebarOpen } = toRefs(props);

const isEmailVerified = ref(false);

const router = useRouter();
const route = useRoute();
const unseenPosts = computed(() => store.getters.unseenPosts);

const selectedHome = computed(() => store.getters.selectedHome as ReqHomesDocument);

watch(route, () => {
  if (isMobile()) {
    emit('closeSidebar');
  }
}, {
  flush: 'pre', immediate: true, deep: true,
});

const conversation = computed(() => store.getters.conversation as IConversations[]);

const recentMessages = computed(() => {
  let countUnreadMessage = 0;
  if (conversation.value && conversation.value.length) {
    countUnreadMessage = conversation.value.reduce((total, el) => total + el.unreadMessages.buyer, 0);
  }
  return countUnreadMessage;
});

onMounted(async () => {
  const auth = await useAuth();
  isEmailVerified.value = auth.isEmailVerified.value;
});

const navbar = computed(() => navigation.value.filter((x) => x.sidebar));

const isCursorAllowed = computed(() => isEmailVerified.value && selectedHome.value);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isMobile)())
    ? (_openBlock(), _createBlock(_unref(TransitionRoot), {
        key: 0,
        as: "template",
        show: _unref(sidebarOpen)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            static: "",
            class: "fixed w-full max-h-[calc(100%-104px)] top-[86px] flex z-2",
            open: _unref(sidebarOpen),
            onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('closeSidebar')))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "transition-opacity ease-linear duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "transition-opacity ease-linear duration-300",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-wrh-gray-extralight" })
                ]),
                _: 1
              }),
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "transition ease-in duration-300 transform",
                "enter-from": "-translate-x-full",
                "enter-to": "translate-x-0",
                leave: "transition ease-out duration-300 transform",
                "leave-from": "translate-x-0",
                "leave-to": "-translate-x-full"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("nav", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navbar), (item, idx) => {
                          return (_openBlock(), _createBlock(_component_router_link, {
                            key: idx,
                            to: { name: item.routeName },
                            class: _normalizeClass([
                    'text-wrh-blue-400 flex items-center px-4 py-3 t-16m rounded-md transition-color duration-200 ease-in-out',
                    {'cursor-not-allowed': !_unref(isCursorAllowed)}]
                  ),
                            "active-class": "!bg-wrh-blue-600 !text-white hover:!bg-wrh-blue-600 hover:!text-white",
                            exact: ""
                          }, {
                            default: _withCtx(({ isActive }) => [
                              _createVNode(SidebarIcon, {
                                name: item.routeName,
                                class: _normalizeClass([
                      isActive
                        ? 'text-white'
                        : 'text-wrh-blue-400 group-hover:text-white',
                        'mr-4 flex-shrink-0 h-7 w-7 transition-color duration-200 ease-in-out',
                    ]),
                                "aria-hidden": "true"
                              }, null, 8, ["name", "class"]),
                              _createTextVNode(" " + _toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class"]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["open"])
        ]),
        _: 1
      }, 8, ["show"]))
    : (_openBlock(), _createElementBlock("aside", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Logo, { class: "w-full h-auto" })
          ]),
          _createElementVNode("nav", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navbar), (item, idx) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: idx,
                to: { name: item.routeName },
                class: _normalizeClass([
              'text-wrh-blue-400 hover:text-wrh-blue-600 hover:border-wrh-blue-light hover:bg-wrh-blue-background border border-transparent group flex items-center px-4 py-3 t-16m  rounded-md transition-color duration-200 ease-in-out',
              {'cursor-not-allowed': !_unref(isCursorAllowed)}]
            ),
                "active-class": "!bg-wrh-blue-600 !text-white hover:!bg-wrh-blue-600 hover:!text-white",
                exact: ""
              }, {
                default: _withCtx(({ isActive }) => [
                  _createVNode(SidebarIcon, {
                    name: item.routeName,
                    class: _normalizeClass([
                isActive
                  ? 'text-white'
                  : 'text-wrh-blue-400 group-hover:text-wrh-blue-600',
                'mr-4 flex-shrink-0 h-7 w-7 transition-color duration-200 ease-in-out',
              ]),
                    "aria-hidden": "true"
                  }, null, 8, ["name", "class"]),
                  _createElementVNode("p", null, _toDisplayString(item.name), 1),
                  (_unref(recentMessages) && item.showUnreadMessage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, " (" + _toDisplayString(_unref(recentMessages)) + ") ", 1))
                    : _createCommentVNode("", true),
                  (_unref(unseenPosts) && item.showUnseenPosts)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, " (" + _toDisplayString(_unref(unseenPosts)) + ") ", 1))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            }), 128))
          ])
        ])
      ]))
}
}

})